import request from '@/CommonDP/utils/request';
// 权限模块
export default {
  queryPermissionTreeForEnterpriseCheck(params) {
    return request
      .get('/permission/queryPermissionTreeForEnterpriseCheck', {
        params
      })
      .then((res) => res);
  },
  getSysRoleUserList(params) {
    return request
      .get('/rolePermission/querySysRoleUserList', { params })
      .then((res) => res);
  },
  addSysRoleUser(params) {
    return request
      .post('/rolePermission/addSysRoleUser', params)
      .then((res) => res);
  },
  delSysRole(roleId) {
    return request
      .get(`/rolePermission/delSysRole?roleId=${roleId}`)
      .then((res) => res);
  },
  delSysRoleUser(roleId, userId, enterpriseId) {
    return request
      .get(
        `/rolePermission/delSysRoleUser?roleId=${roleId}&userId=${userId}&enterpriseId=${enterpriseId}`
      )
      .then((res) => res);
  },
  // 系统角色
  querySysRoleList(enterpriseId) {
    return request
      .get(
        `/rolePermission/querySysRoleList?enterpriseId=${enterpriseId}`
      )
      .then((res) => res);
  },
  updateSysRole(params) {
    return request
      .post('/rolePermission/updateSysRole', params)
      .then((res) => res);
  },
  // 添加系统角色
  saveSysRole(params) {
    return request
      .post(`/rolePermission/addSysRole`, params)
      .then((res) => res);
  },
  // 项目角色
  getPrjRoleTree(enterpriseId, folderArea) {
    return request.get(
      `/rolePermission/queryEnterprisePrjRoleList?enterpriseId=${enterpriseId}&folderArea=${folderArea}`
    );
  },
  // 添加项目角色
  addPrjRole(params) {
    return request
      .post(`/rolePermission/addPrjRole`, params)
      .then((res) => res);
  },
  updatePrjRole(params) {
    return request
      .post('/rolePermission/updatePrjRole', params)
      .then((res) => res);
  },
  // 修改专业
  updateEnterpriseSpec(params) {
    return request.post('/rolePermission/updateEnterpriseSpec', params);
  },
  // 删除专业
  delEnterpriseSpec(id, enterpriseId) {
    return request.get(
      `/rolePermission/delEnterpriseSpec?id=${id}&enterpriseId=${enterpriseId}`
    );
  },
  // 删除专业角色
  delPrjRole(roleId) {
    return request
      .get(`/rolePermission/delPrjRole?roleId=${roleId}`)
      .then((res) => res);
  },
  queryListByuserID(params) {
    return request
      .get('/queryListByUserID', { params })
      .then((res) => res);
  },
  addRolePermission(params) {
    return request
      .post('/rolePermission/addRolePermission', params)
      .then((res) => res);
  },
  // 添加项目角色-专业
  addPrjSpec(params) {
    return request.post('/rolePermission/addPrjSpec', params);
  },
  // 获取专业
  queryPrjSpecList(enterpriseId) {
    return request
      .get(
        `/rolePermission/queryPrjSpecList?enterpriseId=${enterpriseId}`
      )
      .then((res) => res);
  },
  // 所有项目权限人员列表
  prjManagerList(enterpriseId, managerType) {
    return request
      .get(`/enterprise/prj-manager/list?enterpriseId=${enterpriseId}&managerType=${managerType}`)
      .then((res) => res);
  },
  // 所有项目权限人员删除
  prjManagerDelete(enterpriseId, id) {
    return request
      .get(
        `/enterprise/prj-manager/delete?enterpriseId=${enterpriseId}&id=${id}`
      )
      .then((res) => res);
  },
  // 所有项目权限人员 添加
  prjManagerAdd(params) {
    return request.post('/enterprise/prj-manager/add', params);
  },

  // 系统角色上移下移
  rolePermissionMove(params) {
    return request.get("/rolePermission/move", { params });
  },
  syncAllSystemPermissions() {
    return request.post('/permission/syncAllSystemPermissions');
  },

  copyPermissionsFromRoleToOthers(json) {
    return request.post('/permission/copyPermissionsFromRoleToOthers', json);
  },

  // 所有项目权限角色列表
  prjManagerRoleList(enterpriseId, managerType) {
    return request
      .get(`/enterprise/prj-manager/getSysRoleList?enterpriseId=${enterpriseId}&managerType=${managerType}`)
      .then((res) => res);
  },
  // 所有项目权限角色 添加
  prjManagerAddSysRole(params) {
    return request.post('/enterprise/prj-manager/addSysRole', params);
  },
  // 所有项目权限角色删除
  prjManagerDeleteRole(enterpriseId, id) {
    return request
      .get(
        `/enterprise/prj-manager/deleteRole?enterpriseId=${enterpriseId}&id=${id}`
      )
      .then((res) => res);
  },
  // 所有项目权限 批量删除人员
  prjManagerBatchDeleteUser(params) {
    return request.post('/enterprise/prj-manager/batchDeleteUser', params);
  },
  querySysRoleUserListByRoleId(enterpriseId, roleId) {
    return request
      .get(
        `/rolePermission/querySysRoleUserListByRoleId?enterpriseId=${enterpriseId}&roleId=${roleId}`
      )
      .then((res) => res);
  }
};
